import { render, staticRenderFns } from "./categroyLabels.vue?vue&type=template&id=c2ab533e&"
import script from "./categroyLabels.vue?vue&type=script&lang=js&"
export * from "./categroyLabels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports